// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ze0F","actionsCol":"EnrolledClinics_actionsCol__vYp9t"};